export * from "./Certificate.resources";
export * from "./Comment.resources";
export * from "./Content.resources";
export * from "./ContentResource.resources";
export * from "./Courses.resources";
export * from "./Module.resources";
export * from "./Offer.resources";
export * from "./Preference.resources";
export * from "./Student.resources";
export * from "./Team.resources";
